//This file is automatically rebuilt by the Cesium build process.
export default "void primitiveOutlineStage() {\n\
    v_outlineCoordinates = a_outlineCoordinates;\n\
}\n\
";